module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6Dtfc2/tc-custom/9781626812789.jpg?1697127082501",
      "alt": "This image is the cover for the book Worth the Weight"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Worth the Weight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("One woman discovers that her professional rival’s bark is worse than his bite in this charming debut romantic comedy for fans of "), _c('i', [_vm._v("You’ve Got Mail.")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When Kate Richards, the effervescent TV host and the author of kid-friendly cookbooks, runs into Jack Moskowitz at a dog park, sparks fly. He’s attractive, charming, and single. She has no idea that he’s also the one man who could cost Kate her career . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Jack knows exactly who Kate is, though. She tore his company apart on television only the day before! Seeing an opportunity, Jack starts digging up dirt on his nemesis, to put her crusade on ice once and for all. But the more time the two spend together, the more his lie—and his feelings for Kate—spiral out of control."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When Jack and Kate try to tip the scales of romance it brings chaos, heartbreak, and hilarity and more than a few laps around love’s track.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eileen Palma\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0